import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/cn";

const NAV = [
  { to: "/", label: "Overview", end: true },
  { to: "/knowledge", label: "Knowledge" },
  { to: "/assistant", label: "Assistant" },
  { to: "/integrations", label: "Integrations" },
  { to: "/install", label: "Install" },
  { to: "/leads", label: "Leads" },
  { to: "/conversations", label: "Conversations" },
];

export function Shell() {
  const { user, signOut, isDevSession } = useAuth();
  return (
    <div className="flex min-h-screen">
      <aside className="hidden w-[220px] shrink-0 border-r border-border bg-surface lg:flex lg:flex-col">
        <div className="px-5 py-5 text-[18px] font-bold tracking-[-0.03em]">
          Weply
        </div>
        <nav className="flex flex-col gap-0.5 px-3">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                cn(
                  "rounded-control px-3 py-2 text-[14px] font-medium",
                  isActive
                    ? "bg-accent-soft text-accent"
                    : "text-ink hover:bg-surface-2",
                )
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto border-t border-border px-5 py-4 text-[12px] text-muted">
          <p className="truncate">{user?.email}</p>
          {isDevSession ? <p className="text-warn">dev session</p> : null}
          <button
            type="button"
            className="mt-1 text-accent"
            onClick={() => void signOut()}
          >
            Sign out
          </button>
        </div>
      </aside>
      <div className="flex min-w-0 flex-1 flex-col">
        <header className="flex items-center justify-between border-b border-border bg-surface px-4 py-3 lg:hidden">
          <span className="font-bold">Weply</span>
          <nav className="flex gap-3 text-[13px]">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) => (isActive ? "text-accent" : "")}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </header>
        <main className="mx-auto w-full max-w-[1100px] flex-1 px-4 py-6 lg:px-8 lg:py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
